export const tableHeader = (t) => [
  {
    id: 'name',
    type: 'text',
    value: t('common:table.name'),
  },
  {
    id: "gapAnalysisName",
    type: '',
    value: t('dashboard:gapAnalysis.table.gapAnalysis'),
  },
  {
    id: 'created_at',
    type: 'datebr',
    value: t('common:table.date'),
  },
  {
    id: 'action',
    type: 'actions',
    value: '',
  },
]
